import { render, staticRenderFns } from "./CardCancelarPlano.vue?vue&type=template&id=5a5d2880&scoped=true&"
import script from "./CardCancelarPlano.vue?vue&type=script&lang=js&"
export * from "./CardCancelarPlano.vue?vue&type=script&lang=js&"
import style0 from "./CardCancelarPlano.vue?vue&type=style&index=0&id=5a5d2880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5d2880",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a5d2880')) {
      api.createRecord('5a5d2880', component.options)
    } else {
      api.reload('5a5d2880', component.options)
    }
    module.hot.accept("./CardCancelarPlano.vue?vue&type=template&id=5a5d2880&scoped=true&", function () {
      api.rerender('5a5d2880', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Perfil/components/CardCancelarPlano.vue"
export default component.exports